import BaseService from './BaseService'

/** Must match PosGridProductsController::MAX_PRODUCT_IDS (blu-backend). */
export const POS_GRID_PRODUCTS_MAX_IDS = 500

class GridLayoutService extends BaseService {
  constructor() {
    super('/pos')
  }

  async getLayout(scope = 'user') {
    return this.customRequest('get', `/grid-layout`, null, { params: { scope } })
  }

  async getCatalogStamp() {
    return this.customRequest('get', '/catalog-stamp')
  }

  async saveLayout(scope, layout, name = 'Default', isDefault = true) {
    return this.customRequest('put', `/grid-layout`, { scope, layout, name, is_default: isDefault })
  }

  /**
   * All drill-visible POS grid products for the current location.
   * @param {{ includeHasPosModifiers?: boolean }} [options]
   */
  async fetchGridVisibleProducts ({ includeHasPosModifiers = true } = {}) {
    const params = {}
    if (includeHasPosModifiers) {
      params.include_has_pos_modifiers = true
    }

    const response = await this.customRequest('get', '/grid-visible-products', null, { params })
    return response?.products || []
  }

  /**
   * Batch-fetch POS grid product records for layout-placed refs.
   * @param {number[]} productIds
   * @param {{ includeHasPosModifiers?: boolean }} [options]
   */
  async fetchGridProducts (productIds, { includeHasPosModifiers = true } = {}) {
    const ids = [...new Set((productIds || []).map((v) => Number(v)).filter((n) => n > 0))]
    if (!ids.length) return []

    const params = {}
    if (includeHasPosModifiers) {
      params.include_has_pos_modifiers = true
    }

    const response = await this.customRequest('post', '/grid-products', {
      product_ids: ids
    }, { params })

    return response?.products || []
  }
}

export const gridLayoutService = new GridLayoutService()


